"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousSessionHandler = void 0;
var AnonymousSessionHandler = /** @class */ (function () {
    function AnonymousSessionHandler() {
        this.getSessionId = function (connection, callback) {
            throw new Error('With anonymous session handler, use only connection methods without session.');
        };
        this.invalidateSessionId = function (sessionId, callback) {
            throw new Error('With anonymous session handler, use only connection methods without session.');
        };
    }
    return AnonymousSessionHandler;
}());
exports.AnonymousSessionHandler = AnonymousSessionHandler;
